"use strict";

exports.__esModule = true;
exports.formatNumber = formatNumber;
exports.performDraw = performDraw;
exports.round = round;
/**
 * Return true if the draw is successful
 * @param threshold between 0 and 100
 */
function performDraw(threshold) {
  return threshold !== 0 && Math.random() * 100 <= threshold;
}
function round(num, decimals) {
  return +num.toFixed(decimals);
}

/**
 * 保留指定位数的小数
 * @param num 原数据
 * @param decimal 小数位数
 * @param min 限制最小值，否则返回undefined
 * @returns
 */
function formatNumber(num, decimal, min) {
  if (decimal === void 0) {
    decimal = 3;
  }
  if (min === void 0) {
    min = 0;
  }
  if (!num) {
    return num;
  }
  var str = num.toString();
  var index = str.indexOf('.');
  if (index !== -1) {
    str = str.substring(0, decimal + index + 1);
  } else {
    str = str.substring(0);
  }
  var result = parseFloat(str);
  return result >= min ? result : undefined;
}